import React from 'react';
import ReactShow from 'react-show';

import './accordion.css';

class Section extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        if (this.state.open) {
            if (this.props.selected === this.props.idx) {
                this.setState({ open: false });
            }
        } else {
            this.setState({ open: true });
        }
        this.props.updateSelected();
    }

    render() {
        const { idx, children, selected, value } = this.props;
        const expanded = (this.state.open && (selected === idx));
        return (
            <div className='section'>
                <div className='section-header' onClick={this.handleClick}>
                    {value}
                    <div><i className={`accordion-arrow ${expanded ? 'fa fa-angle-up' : 'fa fa-angle-down'}`}/></div>
                </div>
                <ReactShow show={expanded} className='open-wrap'>
                    {children}
                </ReactShow>
            </div>
        );
    }
}

class SectionContent extends React.Component {

    render() {
        const { content } = this.props;
        return (
            <div className='section-content'>
                {content
                    .map((item, idx) => (<div key={idx} className='content-item'>{item}</div>))
                }
            </div>
        );
    }
}

class Accordion extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selected: -1,
            itemSorted: [],
            sortType: 1,
        };
    }

    componentDidMount() {
        let itemSorted = [...this.props.sections];
        itemSorted.sort( ( a, b )=> {
            if (String(a[this.props.keyToSort]).toLowerCase() < String(b[this.props.keyToSort]).toLowerCase() ) {
                return -1;
            }
            if ( String(a[this.props.keyToSort]).toLowerCase() > String(b[this.props.keyToSort]).toLowerCase() ) {
                return 1;
            }
            return 0;
        });

        this.setState({ itemSorted });
    }

    componentWillReceiveProps(nextProps) {
        if ( nextProps.sections ) {
            let itemSorted = [...nextProps.sections];
            itemSorted.sort( ( a, b )=> {
                if (String(a[this.props.keyToSort]).toLowerCase() < String(b[this.props.keyToSort]).toLowerCase() ) {
                    return -1;
                }
                if ( String(a[this.props.keyToSort]).toLowerCase() > String(b[this.props.keyToSort]).toLowerCase() ) {
                    return 1;
                }
                return 0;
            });

            this.setState({ itemSorted });
        }
    }

    changeSortOfItems = ({ target }) => {
        this.setState({ sortType: Number(target.value) });
    }

    render() {
        const { sections = [], showSelect = false } = this.props;

        const itemsArray = this.state.sortType === 1 ? sections : this.state.itemSorted;
        return (
            <main>
                { showSelect &&
                    <section className='select-wrapper'>
                        <label>Ordenação</label>
                        <select value={ this.state.sortType } onChange={ this.changeSortOfItems }>
                            <option value={ 1 } >Padrão</option>
                            <option value={ 2 }> Ordem Alfabetica</option>
                        </select>
                    </section>
                }
                {
                    itemsArray.map((s, idx) =>
                        <Section
                            key={idx}
                            open={this.state.open}
                            updateSelected={() => this.setState({ selected: idx })}
                            idx={idx}
                            selected={this.state.selected}
                            value={s.value}
                            {...this.props}
                        >
                            <SectionContent content={s.items}/>
                        </Section>)
                }
            </main>
        );
    }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/accordion/accordion.js